import React from "react";
import {
  Chip,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  chipsInline: { display: "flex", flexWrap: "wrap" },
  chipInSelect: { marginRight: 6, marginBottom: 6 },
}));

/**
 * MultipleSelectionsWithChip
 * MUI v4 - Select multiplo con chip cancellabili nel renderValue.
 *
 * Props:
 * - label: string
 * - name?: string
 * - options: Array<{ value: string, label: string }>
 * - value: string[]                      // valori selezionati
 * - onChange: (eventLike) => void        // verrà chiamato come onChange({ target: { value: string[] } })
 * - disabled?: boolean
 * - required?: boolean
 * - error?: boolean
 * - helperText?: string
 * - margin?: 'none' | 'dense' | 'normal'
 * - fullWidth?: boolean (default true)
 */
export default function MultipleSelectionsWithChip({
  label,
  name,
  options = [],
  value,
  onChange,
  disabled,
  required,
  error,
  helperText,
  margin = "dense",
  fullWidth = true,
}) {
  const classes = useStyles();
  const selected = Array.isArray(value) ? value : [];

  const emit = (nextArray) => {
    // emette un "fake" event come fa MUI, compatibile con i tuoi handleField
    onChange?.({ target: { value: nextArray, name } });
  };

  const removeItem = (code) => {
    const next = selected.filter((c) => c !== code);
    emit(next);
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      margin={margin}
      required={required}
      error={error}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        name={name}
        value={selected}
        onChange={onChange}
        input={<Input />}
        renderValue={(chosen) => (
          <div className={classes.chipsInline}>
            {(chosen || []).map((code) => {
              const opt = options.find((o) => o.value === code);
              const lbl = opt ? opt.label : code;
              return (
                <Chip
                  key={code}
                  label={lbl}
                  size="small"
                  className={classes.chipInSelect}
                  onMouseDown={(e) => {
                    // evita che il click sul chip apra/chiuda il menu del Select
                    e.stopPropagation();
                  }}
                  onDelete={(e) => {
                    e.stopPropagation();
                    removeItem(code);
                  }}
                />
              );
            })}
          </div>
        )}
        disabled={disabled}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
